import "./container7.css";
import Gamesstack from "../Images/Games stack copy.webp";
function Cont7() {
  return (
    <>
      <div id="container7">
        <img src={Gamesstack} alt="" />
      </div>
    </>
  );
}
export default Cont7;
